import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { StyledCartWrapper } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { useGeneralProductItemContext } from '../context';
import { ISizeProps } from '../model';
import { StyledTotalPriceCol, StyledPriceTotal } from '../styled';

export interface ITotalPriceProps extends ISizeProps, IBasicStyledProps {
  totalPriceTextFreeProduct?: string | React.ReactNode;
  fontSize?: string;
}

export const TotalPrice: ReactFCV<ITotalPriceProps> = ({ totalPriceTextFreeProduct, fontSize, ...rest }) => {
  const { price, itemQuantity, disabled, isDualPriceLayout, isSummaryLayout } = useGeneralProductItemContext();
  const priceTotal = itemQuantity * price;
  return (
    <StyledTotalPriceCol xs={6} sm={isSummaryLayout ? 2 : 1} {...rest} isSummaryLayout={isSummaryLayout}>
      {priceTotal > 0 ? (
        <StyledPriceTotal
          isDualPriceLayout={isDualPriceLayout}
          price={priceTotal}
          disabled={disabled}
          isColumnLayout={true}
          fontSize={fontSize}
        />
      ) : (
        <StyledCartWrapper>{totalPriceTextFreeProduct}</StyledCartWrapper>
      )}
    </StyledTotalPriceCol>
  );
};
TotalPrice.displayName = 'GeneralProductItem.TotalPrice';
